/**
 * <quantity-input> - tilgaengelig antals-stepper (THEME-SPEC 1/6). Progressive
 * enhancement: det native <input type=number> virker uden JS; +/- knapperne er
 * type=button og inerte uden JS. JS wirer dem til at staeppe inputtet inden for
 * min/max/step og dispatcher 'change' saa formular/kurv ser den nye vaerdi.
 *
 * Genbrugbar: PDP buy-buttons nu, kurv-linjer senere. Eneste ansvar er stepper-
 * mekanikken - ingen Section Rendering (kurv-komponenten ejer cart-mutationer).
 */

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    if (!this.input) return;
    this.addEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    event.preventDefault();
    const step = Number(this.input.step) || 1;
    const delta = button.dataset.quantityStep === 'down' ? -step : step;
    const min = this.input.min !== '' ? Number(this.input.min) : 0;
    const max = this.input.max !== '' ? Number(this.input.max) : Infinity;
    const current = Number(this.input.value) || min || 0;
    const next = Math.min(max, Math.max(min, current + delta));
    if (next === current) return;
    this.input.value = String(next);
    // 'change' saa en evt. lytter (kurv-linje senere) reagerer; bubbles ud af komponenten.
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  };
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
